import React from 'react';
import ReactDOM from 'react-dom/client';
import { LoaderProvider } from './context/LoaderContext';
import './assets/css/common.css';
import './assets/css/style.css';
import './assets/css/variables.css';
import './assets/css/customized.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import './utils/errorReporter';

// Dynamic import (not a static one) so the OpenTelemetry SDK — and its
// instrumentation packages — are code-split into their own chunk and never
// touch the main bundle unless tracing is actually enabled at build time.
if (process.env.REACT_APP_ENABLE_TRACING === 'true') {
  import('./utils/tracing').then(({ initTracing }) => initTracing());
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LoaderProvider>
    <App />
    <ToastContainer />
  </LoaderProvider>,
);
